import { Directive, OnInit, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { removeNonDigits } from './mask-util';

@Directive({
  selector: '[formControlName][appSSNMask]',
})
export class SSNMaskDirective implements OnInit {

  constructor(public ngControl: NgControl) { }

  ngOnInit() {
  }

  @HostListener('input', ['$event'])
  onInputEvent(event: InputEvent) {
    this.updateControlAndDomValues(event, (event.target as HTMLInputElement).value);
  }

  private updateControlAndDomValues(event: InputEvent, newSSNValue: string) {
    newSSNValue = newSSNValue || '';
    let domValue = removeNonDigits(newSSNValue);
    if (domValue.length === 0) {
      domValue = '';
    } else if (domValue.length <= 3) {
      domValue = domValue.replace(/^(\d{0,3})/, '$1');
    } else if (domValue.length <= 5) {
      domValue = domValue.replace(/^(\d{0,3})(\d{0,2})/, '$1-$2');
    } else {
      domValue = domValue.replace(/^(\d{0,3})(\d{0,2})(\d*)/, '$1-$2-$3');
    }
    const controlValue = removeNonDigits(domValue);
    if (this.ngControl.control.value !== controlValue) {
      this.ngControl.control.setValue(controlValue);
      this.ngControl.control.markAsDirty({ onlySelf: true });
    }

    this.ngControl.valueAccessor.writeValue(domValue);
    if (event) {
      (event.target as HTMLInputElement).value = domValue;
    }
  }
}
